/**
 * https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#tsunami
 * @type {Tsunami}
 * 津波浸水想定
 */
module.exports = class Tsunami {

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   * To display table
   */
  toDisplay() {
    return [
      {
        alt      : '津波浸水想定の凡例',
        img      : 'https://cdn.jon-api.com/shikaku-map/usage-guide/tsunami.png',
        sourceUrl: 'https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#tsunami'
      }
    ];
  }
}
